<template>
  <div class="container text-justify">
    <h1>Description of Studies</h1>
    <p>
      Wervingsdagen is a joint iniative of the study association of 12 studies.
      In order to give you an impression of what these studies have to offer a short description is added below.
      In the subscription form you have to fill in which study your company is interested in.
      <span
        class="font-weight-bold"
      >We would like to emphasize on the importance of reading this information thoroughly in order to guarantee a better matching between student and company</span>
    </p>
    <div class="study-info" v-for="study in studies" :key="study.id">
      <div class="row study-heading">
        <div class="col-md-8 text-left">
          <img class="study-text" :src="'./studies/' + study.name + '.svg'" :alt="study.name" />
        </div>
        <div class="col-md-4 text-right">
          <img
            class="study-logo"
            :src="'./associations/' + study.association + '.svg'"
            :alt="study.association"
          />
        </div>
      </div>
      <div v-html="study.description"></div>
    </div>
    <router-link to="/">
      <button class="btn btn-secondary">Back</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "StudyInfo",
  data() {
    return {
      showModal: false,
      visibleStudy: {}
    };
  },
  computed: {
    studies() {
      return this.$store.getters.studies;
    }
  }
};
</script>

<style scoped lang="scss">
.study-info {
  position: relative;
  color: #fff;
  background: url("../assets/background/skill-sessions.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 32px;
  margin: 24px 0;
  padding: 32px;
  padding-bottom: 48px;

  .study-heading {
    margin-bottom: 12px;
  }

  .study-text {
    text-align: left;
    max-height: 2.5em;
    margin-bottom: 16px;
    display: block;

    &[alt="Biomedical Engineering"] {
      max-height: 5em;
    }
  }

  .study-logo {
    max-width: 100%;
    height: 4em;
  }
}
</style>
